<template>
  <div class="bs-input">
    <input
      :type="type"
      class="bs-input-inner"
      :class="[types?types:'',inputClass]"
      :placeholder="placeholder"
      :value="value"
      :readonly="readonly"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @focus="$emit('focus', $event.target.value)"
      @click="$emit('click')"
    />
    <!-- 后置内容 -->
    <i class="bs-input-suffix" v-if="suffixIcon">
      <i class="bs-input-suffix-inner" :class="[isReverseIcon?'is_reverse':'',suffixIcon]"></i>
    </i>
  </div>
</template>

<script>
export default {
  name: "BsInput",
  components: {},
  // model:{
  //   event:'input',
  //   value:'value',
  // },
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    readonly:Boolean,
    inputClass:String,
    types:String,
    type:{
      type:String,
      default:'text'
    },
    isReverseIcon:Boolean,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
@import "./index.less";
@import "../../index.less";
</style>


// WEBPACK FOOTER //
// src/components/en/packages/input/src/input.vue